import {
  SegmentDomainProvider,
  useSegmentDomain,
} from '@/src/services/segment/SegmentDomainProvider'
import type * as Config from '../config'
import { Survey2025June } from './Survey2025June'
import { UserSurveyResponseType } from '@api/mesa/graphql'
import { useContext } from 'react'
import { Context } from '..'
import { JsonMap } from '@segment/analytics-react-native'
import { Survey2025JuneFollowup } from './Survey2025JuneFollowup'
import { useEvent } from 'tamagui'

const SurveyRenderer = ({
  surveyId,
  trigger,
}: {
  surveyId: Config.SurveyId
  trigger: Config.Trigger
}) => {
  const { triggerAction } = useSegmentDomain()
  const { submitSurvey } = useContext(Context.SurveysContext)

  const submitSurveyResult = useEvent(
    (responseType: UserSurveyResponseType, responseData?: JsonMap | undefined) => {
      if (responseType === UserSurveyResponseType.DismissedSurvey) {
        void triggerAction('SurveyForm', 'Dismissed')
      } else {
        void triggerAction('SurveyForm', 'Completed', responseData)
      }

      void submitSurvey({
        trigger,
        responseType,
        surveyId,
        responseData,
      })
    },
  )

  switch (surveyId) {
    case '2025_JUNE_SURVEY':
      return <Survey2025June onComplete={submitSurveyResult} />
    case '2025_JUNE_SURVEY_FOLLOW_UP':
      return <Survey2025JuneFollowup onComplete={submitSurveyResult} />
    default:
      surveyId satisfies never
      return null
  }
}

export const SurveyPresenter = ({
  surveyId,
  trigger,
}: {
  surveyId: Config.SurveyId
  trigger: Config.Trigger
}) => (
  <SegmentDomainProvider
    domain="Survey"
    domainAdditionalProperties={{
      surveyId,
      trigger,
    }}
  >
    <SurveyRenderer surveyId={surveyId} trigger={trigger} />
  </SegmentDomainProvider>
)
